import React, { useRef, useEffect, useState} from 'react';
import GiHuman from "../../chart/GiHuman"
import GiBarPlot from "../../chart/GiBarPlot" 

function Screen1BarPlot(props:any) {

    const initData:any = props.initialization;
    const sex:any = props.sex;
   
    const card1:any = useRef();
    const card2:any = useRef();
    let [barPlotData, setBarPlotData] = useState<any[]>();
    let bulkTileData = initData.bulkTileData;
    let [barPlotTitle, setBarPlotTitle] = useState<string>();

    initData.clickOnRowWithScreen1Grid = function(bulkDatas:any[], row:any){

        if(bulkDatas && row && row.Target_seq ===  "Y"){
            setBarPlotTitle(`Variant-allele frequency of "{${row.CHROM}:${row.POS} ${row.REF}>${row.ALT}}" in bulk tissues.`);

             
            bulkDatas.forEach(d => {
                if(bulkTileData[d.bulk_id].bulk_name){
                    d.bulk_name =  bulkTileData[d.bulk_id].bulk_name
                }else{
                    d.bulk_name =  bulkTileData[d.bulk_id].bulk_id
                }
            })
            setBarPlotData(bulkDatas);
        }else{
            setBarPlotData([]);
        }
    }

    let [initGiHumanData, setInitGiHumanData]= useState<any>({ 
        width: initData.human_width,
        height: 580,
        organ: true,
        sex: sex,
      });

    let [initBarPlotData, setInitBarPlotData] = useState<any>({
        width: initData.barplot_width,
        height: 580,
        min_height: 580,
        max_height: 1600,
        value_field:"vaf",
        value_label_name:"VAF",
        label_field:"bulk_name",
        legend_field:"tissue_group",
        tile:{
            tile_fields:["cranio_caudal_axis", "left_right_axis", "anatomy_group", "germ_layer_group"],
            tile_join_field:"bulk_id"
        },
        bar_plot_value: function(d: any){

            const read_depth:number = Number(d.read_depth);
            const n_var:number = Number(d.n_var)
            const sd:number = Math.sqrt(read_depth * d.vaf * (1-d.vaf));
            
            return [(n_var-(sd*2))/read_depth, d.vaf, (n_var+(sd*2))/read_depth];
        },
        callback_after_mouseover_label: function(data:any, active: boolean){
            let selectedOrganName:string = data.tissue_group;

            if(initGiHumanData.activeOrgan){
                initGiHumanData.activeOrgan(selectedOrganName, active);
            }
        },
        callback_after_mouseclick_label: function(data:any, isSelected: boolean, bulkTileData?:any,){
            let selectedOrganName:string = data.tissue_group;
            let x: number = 0;
            let y: number = 0;
            let strokeDasharray: any;

            if(bulkTileData){
                x = bulkTileData[data.bulk_id].x;
                y = bulkTileData[data.bulk_id].y;
                strokeDasharray = bulkTileData[data.bulk_id].strokeDasharray
            }

            if(initGiHumanData.writeSeletedTitle){
                initGiHumanData.writeSeletedTitle(selectedOrganName, isSelected, data.bulk_name, data.color, x, y, strokeDasharray);
            }
        }
    })

    useEffect(() => {
        initGiHumanData.sex = sex;

        if(barPlotData !=undefined && barPlotData.length > 0){
            initBarPlotData.width = card1.current.offsetWidth;
            initGiHumanData.width = card2.current.offsetWidth;
        }

    }, [barPlotData]);

    return (
        <React.Fragment>
        {barPlotData !=undefined && barPlotData.length > 0 && (  
            <div className="row">
            <div className="col-md-8">
                <div className="card card-primary">
                    <div className="card-header">
                    <h3 className="card-title">{barPlotTitle}</h3>
                    </div>
                    <div className="card-body">
                        <div ref={card1}>
                        <GiBarPlot data={barPlotData} bulkTileData={bulkTileData} initialization={initBarPlotData}/>
                        </div>
                        <p className="card-text">
                        When you click name of bulk tissues, you can see the location of those tissues in the right panel.
                        </p>
                    </div>
                </div>
            </div>
            <div className="col-md-4">
                <div className="card card-primary">
                    <div className="card-header">
                    <h3 className="card-title">Location of bulk tissues</h3>
                    </div>
                    <div className="card-body">
                        <div ref={card2}>
                        <GiHuman initialization={initGiHumanData}/>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        )}
        </React.Fragment>
    );
}

export default Screen1BarPlot;